import React from 'react';
import { Country, State } from 'country-state-city';
import styles from './CustomerInformation.module.css';

const CustomerInformation = ({ formData, handleChange, errors }) => {
    const countries = Country.getAllCountries().filter(c => ['US', 'CA', 'MX'].includes(c.isoCode));
    const states = State.getStatesOfCountry(formData.country || 'US');

    const getStateLabel = () => {
        if (formData.country === 'CA') return 'Province';
        return 'State';
    };

    const getZipLabel = () => {
        if (formData.country === 'US') return 'Zip Code';
        return 'Postal Code';
    };

    return (
        <>
            <h2 className={styles.stepTitle}>Customer Information</h2>
            <div className={styles.inputGrid}>
                <div className={styles.inputGroup}>
                    <label htmlFor="first_name">First Name</label>
                    <input type="text" id="first_name" name="first_name" value={formData.first_name} onChange={handleChange} placeholder="e.g., Jane" />
                    {errors.first_name && <div className={styles.errorMessage}>{errors.first_name}</div>}
                </div>
                <div className={styles.inputGroup}>
                    <label htmlFor="last_name">Last Name</label>
                    <input type="text" id="last_name" name="last_name" value={formData.last_name} onChange={handleChange} placeholder="e.g., Doe" />
                    {errors.last_name && <div className={styles.errorMessage}>{errors.last_name}</div>}
                </div>
            </div>
            <div className={styles.inputGrid}>
                <div className={styles.inputGroup}>
                    <label htmlFor="email">Email</label>
                    <input type="text" id="email" name="email" value={formData.email} onChange={handleChange} placeholder="e.g., name@example.com" />
                    {errors.email && <div className={styles.errorMessage}>{errors.email}</div>}
                </div>
                <div className={styles.inputGroup}>
                    <label htmlFor="phone">Practice Phone Number</label>
                    <input type="text" id="phone" name="phone" value={formData.phone} onChange={handleChange} placeholder="e.g., (xxx) xxx-xxxx" />
                    {errors.phone && <div className={styles.errorMessage}>{errors.phone}</div>}
                </div>
            </div>
            <div className={styles.inputGroup}>
                <label htmlFor="org_name">Organization Name / Practice Name</label>
                <input type="text" id="org_name" name="org_name" value={formData.org_name} onChange={handleChange} placeholder="e.g., MedXCom" />
                {errors.org_name && <div className={styles.errorMessage}>{errors.org_name}</div>}
            </div>

            <h3 className={styles.stepSubTitle}>Address Information</h3>
            <div className={styles.inputGroup}>
                <label htmlFor="address">Address</label>
                <input type="text" id="address" name="address" value={formData.address} onChange={handleChange} placeholder="123 Main Street" />
                {errors.address && <div className={styles.errorMessage}>{errors.address}</div>}
            </div>
            <div className={styles.inputGroup}>
                <label htmlFor="address_2">Address Line 2 (Optional)</label>
                <input type="text" id="address_2" name="address_2" value={formData.address_2} onChange={handleChange} placeholder="Suite 100" />
            </div>
            <div className={styles.inputGrid}>
                <div className={styles.inputGroup}>
                    <label htmlFor="country">Country</label>
                    <select id="country" name="country" value={formData.country} onChange={handleChange}>
                        <option value="">Select Country</option>
                        {countries.map(c => (
                            <option key={c.isoCode} value={c.isoCode}>{c.name}</option>
                        ))}
                    </select>
                    {errors.country && <div className={styles.errorMessage}>{errors.country}</div>}
                </div>
                <div className={styles.inputGroup}>
                    <label htmlFor="city">City</label>
                    <input type="text" id="city" name="city" value={formData.city} onChange={handleChange} placeholder="Anytown" />
                    {errors.city && <div className={styles.errorMessage}>{errors.city}</div>}
                </div>
                <div className={styles.inputGroup}>
                    <label htmlFor="state">{getStateLabel()}</label>
                    <select id="state" name="state" value={formData.state} onChange={handleChange}>
                        <option value="">Select {getStateLabel()}</option>
                        {states.map(s => (
                            <option key={s.isoCode} value={s.isoCode}>{s.name}</option>
                        ))}
                    </select>
                    {errors.state && <div className={styles.errorMessage}>{errors.state}</div>}
                </div>
                <div className={styles.inputGroup}>
                    <label htmlFor="zip">{getZipLabel()}</label>
                    <input type="text" id="zip" name="zip" value={formData.zip} onChange={handleChange} placeholder={formData.country === 'US' ? '12345' : 'Postal Code'} />
                    {errors.zip && <div className={styles.errorMessage}>{errors.zip}</div>}
                </div>
            </div>
        </>
    );
};

export default CustomerInformation;
